import styled, { css } from "styled-components";


export const FiltersWrapper = styled.div`
width:100%;
display: flex;
justify-content: right;
align-items: center;
margin-bottom: 15px;
margin-top: 20px;
gap: 10px;
`
export const Filters = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 150%; 
background-color: #fff;
padding:8px;
border-radius: 5px;
span{
    padding-left: 8px;
    padding-right:8px;
}
&:hover{
    background: rgba(230, 234, 239, 0.30);
    }
`
export const Button = styled.button`
display: flex;
justify-content: center;
align-items: center;
background-color:transparent ;
padding-left: 20px;
padding-right: 20px;
border-radius: 5px;
`
export const Wrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height:360px;
padding: 30px;
gap: 5px;
flex-shrink: 0;
border: 1px solid var(--Gray-40, #E1E1E7);
border-radius: 10px;
background: var(--Blue-10, #F3F6F9);
box-shadow: 0px 25px 44px 0px rgba(12, 9, 45, 0.03);

`
export const WrapperButtons = styled.div`
width: 100%;
display: flex;
justify-content: flex-end;
align-items: center;
font-size: 14px;
font-weight: 500;
line-height: 32px;
gap: 15px;
`
export const GoFilterButton = styled.button`
width: 78px;
height: 44px;
padding: 8px 20px;
border-radius: 5px;
${(props) => (props.isDisable ?
        css`
        background-color:var(--Gray-20, #F0F0F3) !important;
        color: var(--Gray-100, #B5B5C3);
        `
        :
        css`
        background-color:rgba(37, 85, 239, 1) !important;
        color: var(--White, var(--White-100, #FFF));

        &:hover{
            background-color:#214DD7 !important;
        }

        `
    )}

`
export const ClearButton = styled.button`
width: 78px;
height: 44px;
padding: 8px 20px;
border-radius: 5px;
margin-right: 16px;
background-color: ${(props) => (props.isDisable ? 'var(--Gray-10, #F8F8F9) !important' : ' rgba(37, 85, 239, 0.08) !important')};  

${(props) => (props.isDisable ?
        css`
        background-color: var(--Gray-10, #F8F8F9) !important;
        color:var(--Gray-100, #B5B5C3);
        `
        :
        css`
        background-color: rgba(37, 85, 239, 0.08) !important;
        color:#2555EF;
        &:hover{
             background: rgba(37, 85, 239, 0.20) !important;
            }
        `
    )}

`
export const WrapperMemberItem = styled.div`
    padding: 10px 30px;
    background-color: ${(props) => (props.isChecked ? '#2555ef' : '#FFFFFF')};  
    color: ${(props) => (props.isChecked ? '#FFFFFF' : '#4D5565')}; 
    border-radius: 32px;
    font-family: var(--MembersWrapperMemberItemFont-family);
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;
    margin-right: 10px;

`
export const MemberItem = styled.div`
div {
        align-self: center;
        height: 6px;
        width: 6px;
        border-radius: 50%;
        display: inline-block;
      }
`